import React from 'react';
import './dashboards.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Tableros BI'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
